// extracted by mini-css-extract-plugin
export default {"heading":"UG","container":"VG","product_section_row":"WG","carousel":"XG","carouselwide":"YG","carouselwrapper":"ZG","blockwrapper":"aH","product_carousel_row":"bH","headingnarrow":"cH","title":"eH"};
    if(module.hot) {
      // 1715632478046
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  